import styles from './FormattedMessage.less';

import React, { Component, PropTypes } from 'react';

export default class FormattedMessage extends Component {

  static propTypes = {
    message: PropTypes.shape({
      parts: PropTypes.isRequired
    })
  };

  renderPart(part, partIndex) {
    const className = (part.highlighted ? styles.highlight : null);

    return (
      <span className={className} key={partIndex}>
        {part.text}
      </span>
    );
  }

  render() {
    const { message } = this.props;

    return (
      <span>
        {message.parts.map(this.renderPart)}
      </span>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/SearchResultPage/components/FormattedMessage/FormattedMessage.js
 **/